import Highway from '@dogstudio/highway';
import gsap from 'gsap';

class Curtain extends Highway.Transition {
	in({ from, done }) {
		// Reset Scroll
		window.scrollTo(0, 0);

		// Remove Old View
		from.remove();
		let curtains = [
			document.querySelector('.curtain.light-blue'),
			document.querySelector('.curtain.blue'),
		];

		gsap.to(curtains, {
			duration: 0.6,
			yPercent: -100,
			ease: 'power4.inOut',
			stagger: {
				amount: 0.1,
			},
			onComplete: () => {
				done();
				document.body.classList.remove('of-hidden');
				gsap.set(curtains, { autoAlpha: 0 });
			},
		});
	}

	out({ done }) {
		// Animation
		let curtains = [
			document.querySelector('.curtain.light-blue'),
			document.querySelector('.curtain.blue'),
		];

		document.body.classList.add('of-hidden');
		gsap.set(curtains, { autoAlpha: 1 });

		gsap.to(curtains, {
			duration: 0.6,
			y: 0,
			ease: 'power4.inOut',
			stagger: {
				amount: 0.1,
			},
			onComplete: () => {
				done();
			},
		});
	}
}

export default Curtain;



// WEBPACK FOOTER //
// ./scripts/highway/transitions/curtain.js